'use client'

export default function Error() {
  return (
    <div className="flex justify-center items-center text-red-500">
      <h2>Something went wrong!</h2>
      <button onClick={() => reset()}>Try again</button>
    </div>
  );
}